import {contactApiHostName} from "../../../endpoint";
import {defaultHeaders} from "../../../headers";

export const removeContact = async (groupId, contactIdList) => {
  try {
    const result = await fetch(
      `${contactApiHostName}/group-users/${groupId}/contact/${contactIdList[0]}`,
      {
        method: "DELETE",
        headers: {
          ...defaultHeaders,
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
        body: JSON.stringify(contactIdList),
      }
    );
    return {
      hasSuccess: result.status === 200,
      data: await result.json(),
    };
  } catch (err) {
    return {
      hasSuccess: false,
      data: err.message,
    };
  }
};
